import { render, staticRenderFns } from "./main.vue?vue&type=template&id=0f5d2322"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=0f5d2322&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f5d2322')) {
      api.createRecord('0f5d2322', component.options)
    } else {
      api.reload('0f5d2322', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=0f5d2322", function () {
      api.rerender('0f5d2322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/channel-popups/src/main.vue"
export default component.exports